import { useEffect } from "react";

const useFocusAndCursorToEnd = <
  T extends HTMLTextAreaElement | HTMLInputElement
>(
  ref: React.RefObject<T>
) => {
  useEffect(() => {
    if (ref.current) {
      ref.current.focus();
      if (ref.current.type !== "number") {
        const val = ref.current.value?.length || 0;
        ref.current.setSelectionRange(val, val);
      }
    }
  }, [ref]);
};

export default useFocusAndCursorToEnd;
